import React, { useContext, useEffect } from 'react'

import { WappContext, withWapp } from 'wapplr-react/dist/common/Wapp'
import getUtils from 'wapplr-react/dist/common/Wapp/getUtils'

import Typography from 'karrierhub-ui/dist/common/src/components/Typography'

import AppContext from '../../App/context'
import Form from '../../Form'

import style from './style.css'
import AccountContext from '../context'

function EmailConfirmation(props) {

    const {
        SubmitProps = {}
    } = props

    const accountContext = useContext(AccountContext)
    const { user, name } = accountContext

    const appContext = useContext(AppContext)
    const context = useContext(WappContext)
    const utils = getUtils(context)

    const { wapp, req } = context

    const query = req.wappRequest.query

    const type = (query?.hash || !user?._id) ? 'confirmation' : 'sendAgain'

    async function onSubmit(e, formData) {
        if (type === 'confirmation') {
            return await utils.sendRequest({
                requestName: name + 'EmailConfirmation',
                args: formData,
                redirect: { pathname: appContext.routes.userRoute + '/:_id', search: '', hash: '' }
            })
        } else if (type === 'sendAgain') {
            return await utils.sendRequest({ requestName: name + 'EmailConfirmationSendAgain', args: formData })
        }
    }

    let formDataFromResolvers = {}

    let formData = {}

    if (type === 'confirmation') {

        try {
            formDataFromResolvers = utils.getGlobalState('res.graphql.mutation.' + name + 'EmailConfirmation.formData')
        } catch (e) {
        }

        formData = {
            ...formDataFromResolvers,
            submit: {
                label: appContext.labels.emailConfirmationSubmitLabel,
                fullWidth: true,
                ...SubmitProps
            }
        }

        if (query.hash && formData.emailConfirmationKey) {
            formData.emailConfirmationKey.value = query.hash
            formData.emailConfirmationKey.disabled = true
        }

        if (query.email && formData.email) {
            formData.email.value = query.email
            formData.email.disabled = true
        }

        if (user?._id && user?.email && formData.email) {
            formData.email.value = user.email
            formData.email.disabled = true
        }

    }

    useEffect(() => {
        if (type === 'confirmation' && user?._id && query.email && query.email !== user.email) {
            async function asyncFunction() {
                await new Promise((resolve) => setTimeout(resolve, 1))
                await appContext.template.current?.actions?.setSnackMessage(appContext.messages.thisIsNotYourEmailConfirmationKey, 6000, 'error')
            }

            // noinspection JSIgnoredPromiseFromCall
            asyncFunction()
        }
    }, [])

    if (type === 'sendAgain') {

        try {
            formDataFromResolvers = utils.getGlobalState('res.graphql.mutation.' + name + 'EmailConfirmationSendAgain.formData')
        } catch (e) {
        }

        formData = {
            ...formDataFromResolvers,
            submit: {
                label: appContext.labels.emailConfirmationSendAgainSubmitLabel,
                className: style.sendAgainButton,
                fullWidth: true,
                ...SubmitProps
            }
        }

        if (user?._id) {
            formData._id.value = user
            formData._id.disabled = true
            formData._id.refPostType = name
        }

    }

    formData['record.col1'] = {
        isContainer: true,
        hiddenContainer: true
    }

    wapp.styles.use(style)

    return (
        <div className={style.emailConfirmation}>
            {
                type === 'sendAgain' ? <Typography className={style.emailConfirmationInfo} variant={'h6'}
                                                   weight={600}>{appContext.messages.emailConfirmationSendAgainInfo}</Typography> : ''
            }
            <Form
                formData={formData}
                onSubmit={onSubmit}
                successMessage={
                    (type === 'confirmation') ? appContext.messages.emailConfirmationSuccessMessage : appContext.messages.emailConfirmationSendAgainSuccessMessage
                }
            />
        </div>
    )

}

export default withWapp(EmailConfirmation)
